import { Component } from '@angular/core'

@Component({
  selector: 'app-open-registration',
  templateUrl: './open-registration.component.html'
})
export class OpenRegistrationComponent {}
